import { VIEW } from 'interfaces';
import * as React from 'react';
import { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import APIService from 'services/APIService';

const Activate = React.memo(() => {
    const { token } = useParams();
    const navigate = useNavigate();
    const tokenLogin = async () => {
        await APIService.tokenLogin(token)
       navigate(`/${VIEW.EXPORT_COMPONENT}`);
    }
    useEffect(() => {
        tokenLogin()
    }, [token]);

    return (
        <div
            style={{
                color: 'white',
                height: '100%',
                textAlign: 'center',
                width: '100%',
            }}>
            Loading
        </div>
    );
});

export default Activate;
